import React, { Component } from "react";
import { withLanguage } from "../utils/LanguageContext";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

class LanguageSelector extends Component {
  componentDidMount = () => {
    if (!this.props.saveLocally) {
      localStorage.removeItem("currentLanguage");
    }
  };

  handleChange = (e) => {
    this.props.changeLanguage(e.target.value);
  };

  render() {
    const { currentLanguageCode } = this.props;
    if (!this.props.saveLocally) {
      return (
        <div className="languageselector-wrapper">
          <i className="fa fa-globe-americas" aria-hidden="true" />
          <FormControl sx={{ m: 1, minWidth: 100, textAlign: "center" }}>
            <Select
              value={currentLanguageCode}
              style={{ color: "white" }}
              onChange={this.handleChange}
              inputProps={{
                name: "lang",
                id: "lang",
              }}
            >
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="fr">Français</MenuItem>
            </Select>
          </FormControl>
        </div>
      );
    }
    return null;
  }
}

export default withLanguage(LanguageSelector);
